import "./newMela.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { useSelector } from "react-redux";

const NewMela = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const melaData = state?.mela || {}; // Extract mela data or use an empty object

  // populate formData with melaData if editing
  const [formData, setFormData] = useState({
    userId: melaData.userId || userIdRedux,
    melaName: melaData.melaName || "",
  });

  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};
    if (!formData.melaName) errors.melaName = "Full Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.fullName))
    //   errors.fullName = "Full Name name must be a string.";
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    // Prepare the form data for submission (add images if available)
    const formDataToSubmit = new FormData();

    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("melaName", formData.melaName);

    /**
     *
     * choosing URL whether to update or add mela
     *
     */
    const MAIN_URL = melaData._id
      ? `${BASE_URL}/api/mela/updateMelaName/${melaData._id}`
      : `${BASE_URL}/api/mela/addMelaName`;

    let response = "";
    try {
      if (melaData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/mela");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/mela");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 6 }}
                name="melaName"
                label="Mela Name"
                type="text"
                value={formData.melaName}
                onChange={handleChange}
                error={Boolean(errors.melaName)}
                helperText={errors.melaName}
                fullWidth
                margin="normal"
                required
              />
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewMela;
